import React, { useEffect } from 'react'
import SelectInput from 'src/Common/ui/selectInput'
import { useForm } from 'react-hook-form'
import * as GovernanceApi from '../../API/GovernenceAPI'
import ResetIcon from 'src/Common/ui/resetIcon'
import { Tooltip } from '@mui/material'

function TcRACI ({ disableDep = false, matrixOptions, setMatrixOptions, setLoading, setTransferTableSearchValue, resetShow }) {
    const { errors, control } = useForm()
    const orgId = localStorage.getItem('orgId')
    const stateUpdater = (key, value) => {
        setMatrixOptions(prev => ({ ...prev, [key]: value }))
    }
    const clearAll = () => {
        stateUpdater('department', null)
        stateUpdater('user', null)
        stateUpdater('userOptions', [])
        stateUpdater('role', null)
        stateUpdater('roleOptions', [])
        setTransferTableSearchValue('')
    }
    useEffect(() => {
        if (disableDep) {
            handleDepartmentChange(matrixOptions?.department)
        }
    }, [disableDep])
    useEffect(() => {
        try {
            GovernanceApi.getDepOrg(orgId).then(({ data }) => {
                stateUpdater('departmentOptions', data.map(obj => {
                    return {
                        value: obj.id,
                        label: obj.name
                    }
                }))
            })
            if (resetShow) {
                clearAll()
            }
        } catch (error) {
            console.log(error)
        }
    }, [location.pathname])
    function handleuserChange (user) {
        setTransferTableSearchValue('')
        if (!user) return stateUpdater('user', null)

        stateUpdater('user', user)
    }

    const handleRoleChange = async (roleId) => {
        setTransferTableSearchValue('')
        if (!roleId) {
            stateUpdater('role', null); stateUpdater('user', '')
            return
        }
        stateUpdater('role', roleId)
        stateUpdater('user', null)
        setLoading(true)
        try {
            GovernanceApi.getUserByRole(roleId, orgId, matrixOptions?.department)
                .then(({ data }) => {
                    stateUpdater('userOptions', data.map(obj => {
                        return {
                            value: obj.id,
                            label: obj.name
                        }
                    }))
                })
            setLoading(false)
        } catch (error) {
            console.error('Error fetching departments:', error)
        }
    }

    const handleDepartmentChange = async (deptId) => {
        setTransferTableSearchValue('')
        if (!deptId) {
            stateUpdater('department', null)
            stateUpdater('role', null)
            return
        }
        setLoading(true)
        stateUpdater('user', null)
        stateUpdater('userOptions', [])
        stateUpdater('role', null)
        stateUpdater('roleOptions', [])
        try {
            stateUpdater('department', deptId)
            GovernanceApi.getRolebyDep(deptId)
                .then(({ data }) => {
                    stateUpdater('roleOptions', data.map(obj => {
                        return {
                            value: obj.id,
                            label: obj.name
                        }
                    }))
                })
        } catch (error) {
            console.error('Error fetching users:', error)
        }
        setLoading(false)
    }

    const noneImplementor = (list) => {
        return [ ...list, { label: 'None', value: null }]
    }
    // Get Org ID from LocalStorage
    return (
        <>

            <div className="w-full flex px-6 gap-2">
                <div className="gap-4 w-full grid grid-cols-3">

                    <div>

                        <SelectInput
                            placeholder="Select Department"
                            name="department"
                            label='Department'
                            control={control}
                            className='!input-grc bg-card'
                            errors={errors}
                            rules={{ required: 'Department is required' }}
                            options={noneImplementor(matrixOptions?.departmentOptions)}
                            value={matrixOptions.department}
                            onValueChange={handleDepartmentChange}
                            readOnly={disableDep}
                        />

                    </div>
                    <div>
                        <SelectInput
                            readOnly={matrixOptions.department === null}
                            placeholder="Select Role"

                            name="role"
                            control={control}
                            label='Role'
                            className='!input-grc bg-card'
                            errors={errors}
                            rules={{ required: 'Role is required' }}
                            options={noneImplementor(matrixOptions?.roleOptions)}
                            value={matrixOptions?.role}
                            onValueChange={handleRoleChange}
                            disabled={!matrixOptions.department}
                        />
                    </div>
                    <div>
                        {/* User Field */}
                        <SelectInput
                            readOnly={matrixOptions.role === null}
                            placeholder="Select User"
                            name="user"
                            label='User'
                            control={control}
                            className='!input-grc bg-card'

                            errors={errors}
                            rules={{ required: 'User is required' }}
                            options={noneImplementor(matrixOptions?.userOptions)}
                            value={matrixOptions?.user}
                            onValueChange={handleuserChange}

                            disabled={!matrixOptions?.role}
                        />
                    </div>

                </div>
                { resetShow && <div className='flex items-center cursor-pointer pt-3'>
                    <Tooltip title="Reset" placement="top" componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}>
                        <div><ResetIcon color={'hsl(var(--primary))'} size={20} onClick={clearAll}/></div>
                    </Tooltip>

                </div>}
                {/* <div className=''>
                    <div className="flex justify-end space-x-4">
                        <Box>
                            <Button onClick={() => handleCancel()}
                                variant='outline'
                                style={{ color: 'hsl(var(--destructive))', borderColor: 'hsl(var(--destructive))' }}
                            >
                         Cancel
                            </Button>
                        </Box>
                        <Box>
                            <Button onClick={handleSubmit(handleApply)}
                            >
                         Apply
                            </Button>
                        </Box>
                    </div>
                </div> */}
            </div>
        </>
    )
}

export default TcRACI
